import { defineEntitlement, defineResourceEntitlement } from '#layers/access/utils/entitlements';

// Workspaces
export const canCreateWorkspace = defineEntitlement('workspace', 'create');
export const canDeleteWorkspace = defineResourceEntitlement('workspace', 'delete');
export const canUpdateWorkspace = defineResourceEntitlement('workspace', 'update');

// Organization roles
export const canAssignOrganizationRole = defineResourceEntitlement('orgRole', 'assign');

// API keys
export const canCreateApiKey = defineEntitlement('apiKey', 'create');
export const canReadApiKeys = defineEntitlement('apiKey', 'read');
export const canDeleteApiKey = defineResourceEntitlement('apiKey', 'delete');
export const canUpdateApiKey = defineResourceEntitlement('apiKey', 'update');

// Service accounts
export const canCreateServiceAccount = defineEntitlement('serviceAccount', 'create');
export const canReadServiceAccounts = defineEntitlement('serviceAccount', 'read');
export const canUpdateServiceAccount = defineResourceEntitlement('serviceAccount', 'update');
export const canDeleteServiceAccount = defineResourceEntitlement('serviceAccount', 'delete');

// Organization members
export const canAddOrganizationMember = defineEntitlement('orgMembers', 'add');
export const canReadOrganizationMembers = defineEntitlement('orgMembers', 'read');
export const canReadOrganizationInvites = defineEntitlement('orgMembers', 'readInvites');
export const canDeleteOrganizationMember = defineEntitlement('orgMembers', 'delete');
export const canUpdateUser = defineResourceEntitlement('user', 'update');

// Organization settings
export const canEditOrganizationSettings = defineEntitlement('orgSettings', 'edit');
export const canReadOrganizationLicense = defineEntitlement('orgLicense', 'read');
export const canManageOrganizationLicense = defineEntitlement('orgLicense', 'manage');

// Authentication providers
export const canCreateAuthProvider = defineEntitlement('authProvider', 'create');
export const canReadAuthProviders = defineEntitlement('authProvider', 'read');
export const canUpdateAuthProvider = defineEntitlement('authProvider', 'update');
export const canDeleteAuthProvider = defineEntitlement('authProvider', 'delete');

// OpenAPI schema
export const canReadSystemOpenApiSchema = defineEntitlement('systemOpenApiSchema', 'read');

// Audit logs
export const canReadAuditLogs = defineEntitlement('auditLog', 'read');

// Files
export const canDeleteFile = defineResourceEntitlement('file', 'delete');

// Extensions
export const canReadOrganizationExtensions = defineEntitlement('extension', 'read');
